import moment from 'moment';
import axios from 'src/utils/axios';

// const TH_TO_EN_MAPPING = {
//     "-": "`",
//     ๅ: "1",
//     "/": "2",
//     _: "3",
//     ภ: "4",
//     ถ: "5",
//     "ุ": "6",
//     "ึ": "7",
//     ค: "8",
//     ต: "9",
//     จ: "0",
//     ข: "-",
//     ช: "=",
//     ๆ: "q",
//     ไ: "w",
//     ำ: "e",
//     พ: "r",
//     ะ: "t",
//     "ั": "y",
//     "ี": "u",
//     ร: "i",
//     น: "o",
//     ย: "p",
//     บ: "[",
//     ล: "]",
//     ฟ: "a",
//     ห: "s",
//     ก: "d",
//     ด: "f",
//     เ: "g",
//     "้": "h",
//     "่": "j",
//     า: "k",
//     ส: "l",
//     ว: ";",
//     ง: "'",
//     ผ: "z",
//     ป: "x",
//     แ: "c",
//     อ: "v",
//     "ิ": "b",
//     "ื": "n",
//     ท: "m",
//     ม: ",",
//     ใ: ".",
//     ฝ: "/",
//     "๐": "Q",
//     '"': "W",
//     ฎ: "E",
//     ฑ: "R",
//     ธ: "T",
//     "ํ": "Y",
//     "๊": "U",
//     ณ: "I",
//     ฯ: "O",
//     ญ: "P",
//     ฐ: "{",
//     ",": "}",
//     ฤ: "A",
//     ฆ: "S",
//     ฏ: "D",
//     โ: "F",
//     ฌ: "G",
//     "็": "H",
//     "๋": "J",
//     ษ: "K",
//     ศ: "L",
//     ซ: ":",
//     ".": '"',
//     ฅ: "|",
//     "(": "Z",
//     ")": "X",
//     ฉ: "C",
//     ฮ: "V",
//     "ฺ": "B",
//     "์": "N",
//     "?": "M",
//     ฒ: "<",
//     ฬ: ">",
//     ฦ: "?",
//     " ": " ",
// };

const EN_TO_TH_MAPPING = {
    "`": "-",
    1: "ๅ",
    2: "/",
    3: "_",
    4: "ภ",
    5: "ถ",
    6: "ุ",
    7: "ึ",
    8: "ค",
    9: "ต",
    0: "จ",
    "-": "ข",
    "=": "ช",
    q: "ๆ",
    w: "ไ",
    e: "ำ",
    r: "พ",
    t: "ะ",
    y: "ั",
    u: "ี",
    i: "ร",
    o: "น",
    p: "ย",
    "[": "บ",
    "]": "ล",
    a: "ฟ",
    s: "ห",
    d: "ก",
    f: "ด",
    g: "เ",
    h: "้",
    j: "่",
    k: "า",
    l: "ส",
    ";": "ว",
    "'": "ง",
    z: "ผ",
    x: "ป",
    c: "แ",
    v: "อ",
    b: "ิ",
    n: "ื",
    m: "ท",
    ",": "ม",
    ".": "ใ",
    "/": "ฝ",
    Q: "๐",
    W: '"',
    E: "ฎ",
    R: "ฑ",
    T: "ธ",
    Y: "ํ",
    U: "๊",
    I: "ณ",
    O: "ฯ",
    P: "ญ",
    "{": "ฐ",
    "}": ",",
    A: "ฤ",
    S: "ฆ",
    D: "ฏ",
    F: "โ",
    G: "ฌ",
    H: "็",
    J: "๋",
    K: "ษ",
    L: "ศ",
    ":": "ซ",
    '"': ".",
    "|": "ฅ",
    Z: "(",
    X: ")",
    C: "ฉ",
    V: "ฮ",
    B: "ฺ",
    N: "์",
    M: "?",
    "<": "ฒ",
    ">": "ฬ",
    "?": "ฦ",
    " ": " ",
};

export function convertTextToThaiQwerty(text) {
    let result = "";
    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        const convertedChar = EN_TO_TH_MAPPING[char] || char;
        result += convertedChar;
    }
    return result;
}

export function isNumeric(value) {
    return /^\d+$/.test(value);
}

export function parseUrlParams() {
    const params = new URLSearchParams(window.location.search.substr(1));
    return params.get("d") ? params.get("d").split(",") : null;
}
export async function getTransactionSession(params) {
    const response = await axios.get(`/basic-api/vw_transaction_session`, {
        params: params
    });
    return response.data;
}
export const getRule_by_AreaId = async (params) => {
    const response = await axios.get(
        `/basic-api/parking_fee_apply_rule`,
        {
            params
        }
    );
    const rule_id = await response?.data?.data?.[0]?.rule_id;
    const responserule = await axios.get(
        `/basic-api/parking_fee_rule`, { params: { id: rule_id } }
    );
    const data = await responserule.data;
    var dummy = { ...data?.data[0] };
    const response1 = await axios.get(
        `/basic-api/parking_fee_rule_peroid`,
        { params: { rule_id: dummy?.id, order_by: "start_time", sort: "asc" } }
    );
    const data1 = await response1.data;
    dummy.peroid = await data1?.data || []
    for await (const [index, value] of dummy.peroid.entries()) {
        const res = await axios.get(
            `/basic-api/parking_fee_rule_peroid_amount`,
            { params: { rule_peroid_id: value?.id, order_by: "amount_no", sort: "asc" } }
        );
        const data2 = await res.data;
        dummy.peroid[index].peroid_amount = await data2?.data || [];
    }
    if (!!dummy) return dummy
};

export async function calculateFees(datetimeIn, datetimeNow, parkingRuleJSON) {
    const free_hour = parkingRuleJSON?.starter_free_minute || 0;
    // const cal_rate = rate;
    const datetime_in = moment(datetimeIn);
    const datetime_now = moment(datetimeNow);
    const difftime = datetime_now.diff(datetime_in, "minutes");
    const difftimefree = difftime - free_hour
    const difftime_h = Math.floor(difftime / 60);
    const difftime_m = difftime % 60;
    const difftime_ss = Number(difftime - free_hour)
    const summ = await calculateMoney(datetime_in, datetime_now, parkingRuleJSON);
    return {
        datetime_in: datetime_in.format("DD/MM/YYYY HH:mm:ss"),
        datetime_now: datetime_now.format("DD/MM/YYYY HH:mm:ss"),
        difftime_h,
        difftime_m,
        difftime_h_cal: Math.ceil(difftime_ss / 60),
        freeH: Math.floor(free_hour / 60),
        freeM: free_hour % 60,
        fee_h: Math.floor(difftimefree / 60),
        fee_m: difftimefree % 60,
        summ: summ || 0,
        showParkingFee: summ > 0,
    };
}

export function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}
const calculateMoney = async (datetimeIn, datetimeNow, parkingRuleJSON) => {
    const arrayDay = await convertToArray(datetimeIn, datetimeNow);
    let summ = 0;
    // const parkingRuleJSON = dataRuleFee?.find(
    //     (e) => e.id == dataArea?.find((s) => s.id == data.area_id)?.rule_id
    // );
    if (!parkingRuleJSON) {
        return 0;
    }
    let starterfrees = parkingRuleJSON.starter_free_minute;
    // console.log(arrayDay);
    for await (const [index, value] of arrayDay.entries()) {
        // console.log(value)
        // console.log(moment(value.entry).format("HH:mm:ss"))
        // console.log(moment(value.exit).format("HH:mm:ss"))
        const { totalFee, starterfree } = await calculateParkingFee(
            moment(value.entry).format("HH:mm:ss"),
            moment(value.exit).format("HH:mm:ss"),
            parkingRuleJSON,
            starterfrees
        );
        // console.log(totalFee);
        // console.log(starterfree);
        summ += totalFee;
        starterfrees = starterfree;
    }
    if (arrayDay?.length > 1) {
        summ +=
            parseFloat(parkingRuleJSON?.over_night_charge) * (arrayDay?.length - 1);
    }
    return summ
};
async function convertToArray(entry, exit) {
    // แปลงข้อมูลเวลาเข้าและออกเป็นออบเจกต์ Moment
    const entryminutes = moment(entry, "YYYY-MM-DD HH:mm:ss").minutes();
    const entrysecond = moment(entry, "YYYY-MM-DD HH:mm:ss").seconds();
    const entryMoment = moment(entry, "YYYY-MM-DD HH:mm:ss");
    const exitMoment = moment(exit, "YYYY-MM-DD HH:mm:ss");
    const exitMoment2 = moment(exit, "YYYY-MM-DD HH:mm:ss").startOf("day");

    // console.log(entryMoment);
    // console.log(exitMoment);
    // สร้างอาร์เรย์เพื่อเก็บข้อมูลแยกตามวัน
    const separatedData = [];

    // วนลูปจนกว่า entryMoment จะน้อยกว่าหรือเท่ากับ exitMoment
    while (entryMoment.isSameOrBefore(exitMoment)) {
        // console.log(entryMoment.isSame(exitMoment2))
        const currentDateData = {
            entry: entryMoment.format("YYYY-MM-DD HH:mm:ss"),
            exit: entryMoment.isSameOrAfter(exitMoment2)
                ? exitMoment.format("YYYY-MM-DD HH:mm:ss")
                : entryMoment
                    .clone()
                    .add(1, "day")
                    .startOf("day")
                    .add(entryminutes, "minutes")
                    .add(entrysecond, "seconds")
                    .format("YYYY-MM-DD HH:mm:ss"),
        };
        separatedData.push(currentDateData);
        entryMoment
            .add(1, "day")
            .startOf("day")
            .add(entryminutes, "minutes")
            .add(entrysecond, "seconds"); // เพิ่มเวลาเข้าไปอีก 1 วันและตั้งเวลาเป็นต้นฉบับของวันนั้น
    }
    return separatedData;
}
async function calculateParkingFee(entryTime, exitTime, rule, starterfrees) {
    // Convert entryTime and exitTime to Date objects
    const dsss = JSON.parse(JSON.stringify(rule));
    const entry = moment("2000-01-01T" + entryTime, "YYYY-MM-DDTHH:mm:ss");
    const exit = moment("2000-01-01T" + exitTime, "YYYY-MM-DDTHH:mm:ss");
    if (entry.isSameOrAfter(exit)) exit.add(1, "day");
    // Calculate parking fee
    let totalFee = 0;
    let starterfree = starterfrees;
    for await (const [index, value] of rule.peroid.entries()) {
        const startTime = moment(
            "2000-01-01T" + value.start_time,
            "YYYY-MM-DDTHH:mm:ss"
        );
        const endTime = moment(
            "2000-01-01T" + value.end_time,
            "YYYY-MM-DDTHH:mm:ss"
        );
        if (
            startTime.isBetween(entry, exit) ||
            startTime.isSame(entry) ||
            startTime.isSame(exit) ||
            endTime.isBetween(entry, exit) ||
            endTime.isSame(entry) ||
            endTime.isSame(exit) ||
            entry.isBetween(startTime, endTime) ||
            entry.isSame(startTime) ||
            entry.isSame(endTime) ||
            exit.isBetween(startTime, endTime) ||
            exit.isSame(startTime) ||
            exit.isSame(endTime)
        ) {
            const start =
                startTime.isBetween(entry, exit) ||
                    startTime.isSame(entry) ||
                    startTime.isSame(exit)
                    ? startTime
                    : entry;
            const end =
                endTime.isBetween(entry, exit) ||
                    endTime.isSame(entry) ||
                    endTime.isSame(exit)
                    ? endTime
                    : exit;
            // console.log(start)
            // console.log(end)
            const duration = moment.duration(end.diff(start));
            const minutes = duration.asMinutes();
            const roundedMinutes = Math.ceil(minutes);
            let totalMinutes = roundedMinutes;
            // console.log(totalMinutes)
            if (starterfree >= 1 && rule?.include_free_minute == 0) {
                if (starterfree >= totalMinutes) {
                    starterfree -= totalMinutes;
                    totalMinutes -= totalMinutes;
                } else {
                    totalMinutes -= starterfree;
                    starterfree -= starterfree;
                }
            }
            // console.log(totalMinutes)
            for await (const [index1, value1] of value.peroid_amount.entries()) {
                const amountMinutes = value1.total_time;
                const amountRate = value1.amount_per_time;
                // console.log(value1.total_time)
                // console.log(value1.amount_per_time)
                if (index1 + 1 == value.peroid_amount?.length) {
                    const sss = parseFloat(
                        parseFloat(totalMinutes) / parseFloat(amountMinutes)
                    );
                    const aaa = Math.ceil(sss) * parseFloat(amountRate);
                    totalFee += aaa;
                } else {
                    totalMinutes -= amountMinutes;
                    totalFee += amountRate;
                }
            }
        }
    }
    if (totalFee > rule.max_daily_charge) {
        totalFee = rule.max_daily_charge;
    }
    return { totalFee, starterfree };
}